import styled from 'styled-components';
import {
  companyColor,
  defaultColor,
  radius,
  spacing,
} from 'styles/theme';

export const Options = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing('extraSmall')};
  background-color: ${defaultColor('backgroundLight')};
  border-radius: ${radius('medium')};
  padding: 4px;
`;

export const Option = styled.button`
  flex: 1 1 0;
  cursor: pointer;
  border: none;
  border-radius: ${radius('medium')};
  padding: 8px 12px;
  font-size: 0.875rem;
  background-color: ${({ isActive }) => (isActive ? companyColor('font') : 'transparent')};
  color: ${({ isActive }) => (isActive ? defaultColor('white') : defaultColor('gray'))};

  &:hover {
    color: ${({ isActive }) => (isActive ? defaultColor('white') : defaultColor('dark'))};
  }
`;
